import { render, staticRenderFns } from "./DocumentSelect.vue?vue&type=template&id=4fe59967&scoped=true"
import script from "./DocumentSelect.vue?vue&type=script&lang=js"
export * from "./DocumentSelect.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelect.vue?vue&type=style&index=0&id=4fe59967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe59967",
  null
  
)

export default component.exports